var SHARP_YB1FA = {
  name: "SHARP YB1FA",
  defaultCommandIndex: 1,
  commands: [
    {
      mode: "AC_MODE_OFF",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_NULL",
      command: [139,0,5,175,35,28,17,237,2,30,6,222,2,182,1,245,2,148,77,226,2,0,0,164,148,146,73,36,146,73,36,146,73,41,73,72,146,73,36,146,73,73,36,146,73,36,148,168,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,225,2,181,1,152,35,24,17,241,2,20,6,243,2,138,77,241,2,0,0,78,127,255,243,243,57,143,255,207,255,230,97,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,235,2,179,1,120,35,29,17,236,2,10,6,244,2,138,77,12,3,0,0,78,124,255,252,252,206,99,255,243,255,252,152,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,237,2,177,1,118,35,28,17,236,2,4,6,244,2,118,77,10,3,0,0,78,126,127,252,252,206,99,255,243,255,249,38,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,237,2,179,1,131,35,26,17,236,2,3,6,246,2,114,77,246,2,0,0,78,124,159,255,63,51,152,255,252,255,255,200,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,133,35,19,17,237,2,155,1,243,2,4,6,249,2,121,77,243,2,0,0,149,42,170,85,85,85,42,169,74,148,85,85,85,82,170,170,170,165,72,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,234,2,179,1,124,35,16,17,241,2,10,6,241,2,149,77,239,2,0,0,78,124,207,255,63,51,152,255,252,255,255,50,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,236,2,178,1,120,35,28,17,236,2,4,6,249,2,147,77,235,2,0,0,78,126,79,255,63,51,152,255,252,255,254,76,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,129,35,23,17,236,2,167,1,241,2,5,6,236,2,149,77,245,2,0,0,149,42,164,149,85,85,74,170,82,165,21,85,85,84,170,170,170,170,146,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,222,2,178,1,120,35,18,17,243,2,29,6,15,3,143,77,234,2,0,0,78,127,159,252,252,206,99,255,243,255,249,146,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,231,2,159,1,159,35,24,17,238,2,10,6,248,2,141,77,235,2,0,0,78,124,231,255,63,51,152,255,252,255,255,36,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,227,2,182,1,126,35,23,17,238,2,17,6,247,2,135,77,236,2,0,0,78,126,103,255,63,51,152,255,252,255,254,73,33,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,236,2,179,1,159,35,29,17,238,2,5,6,247,2,138,77,231,2,0,0,78,124,153,255,207,204,230,63,255,63,255,248,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,123,35,31,17,234,2,179,1,236,2,7,6,7,3,142,77,252,2,0,0,149,42,170,74,170,170,149,84,165,74,42,170,170,169,85,85,85,82,168,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,235,2,157,1,124,35,21,17,241,2,7,6,244,2,146,77,243,2,0,0,78,124,201,255,207,204,230,63,255,63,255,206,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,127,35,26,17,237,2,178,1,236,2,6,6,241,2,130,77,250,2,0,0,149,42,169,37,85,85,74,170,82,165,21,85,85,84,170,170,170,169,42,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [139,0,5,227,2,178,1,126,35,28,17,239,2,19,6,7,3,140,77,239,2,0,0,78,79,255,252,252,206,99,255,243,255,249,152,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [139,0,5,235,2,164,1,128,35,19,17,241,2,10,6,11,3,120,77,248,2,0,0,78,79,63,255,63,51,152,255,252,255,255,38,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [139,0,5,148,35,21,17,240,2,177,1,241,2,1,6,10,3,142,77,246,2,0,0,149,37,84,170,170,170,149,84,165,74,42,170,170,169,85,85,85,82,74,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [139,0,5,237,2,177,1,128,35,254,16,3,3,7,6,246,2,135,77,253,2,0,0,78,79,39,255,207,204,230,63,255,63,255,242,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [139,0,5,236,2,156,1,239,2,3,6,124,35,24,17,239,2,121,77,247,2,0,0,46,191,127,251,246,236,127,254,255,254,232,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [139,0,5,231,2,181,1,152,35,24,17,240,2,10,6,238,2,130,77,241,2,0,0,78,79,51,255,207,204,230,63,255,63,255,204,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [139,0,5,142,35,23,17,238,2,10,6,232,2,180,1,11,3,149,77,245,2,0,0,164,169,36,169,36,146,73,37,36,146,148,148,137,36,146,73,36,148,146,73,36,146,73,82,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [139,0,5,124,35,20,17,237,2,168,1,240,2,234,5,236,2,136,77,244,2,0,0,149,37,82,74,170,170,165,85,41,82,138,170,170,170,85,85,85,85,73,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [139,0,5,233,2,182,1,148,35,24,17,239,2,8,6,245,2,134,77,9,3,0,0,78,79,231,255,63,51,152,255,252,255,254,100,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [139,0,5,237,2,181,1,156,35,23,17,240,2,5,6,244,2,134,77,243,2,0,0,78,79,57,255,207,204,230,63,255,63,255,201,33,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [139,0,6,159,35,18,17,238,2,152,1,242,2,2,6,249,2,136,77,203,2,1,2,12,3,0,0,149,37,84,165,85,85,74,170,82,165,21,85,85,84,170,170,170,21,36,144,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [139,0,5,153,35,22,17,238,2,179,1,240,2,2,6,240,2,147,77,13,3,0,0,149,37,82,82,170,170,165,85,41,82,138,170,170,170,85,85,85,85,84,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [139,0,5,132,35,17,17,238,2,179,1,247,2,2,6,250,2,141,77,253,2,0,0,149,37,85,37,85,85,74,170,82,165,21,85,85,84,170,170,170,169,84,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [139,0,5,235,2,153,1,152,35,29,17,237,2,0,6,235,2,140,77,245,2,0,0,78,79,50,127,243,243,57,143,255,207,255,243,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [139,0,5,238,2,181,1,157,35,30,17,235,2,1,6,240,2,132,77,240,2,0,0,78,79,146,127,243,243,57,143,255,207,255,228,225,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [139,0,5,118,35,30,17,236,2,7,6,233,2,182,1,247,2,139,77,241,2,0,0,164,165,36,146,73,36,146,73,73,36,165,37,34,73,36,146,73,37,36,146,73,36,146,82,144,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [139,0,5,124,35,26,17,238,2,31,6,221,2,180,1,238,2,145,77,245,2,0,0,164,165,37,36,146,73,36,146,146,73,74,74,68,146,73,36,146,74,73,36,146,73,36,149,33,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [139,0,5,120,35,22,17,235,2,174,1,243,2,3,6,241,2,145,77,242,2,0,0,149,41,84,170,170,170,149,84,165,74,42,170,170,169,85,85,85,82,74,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [139,0,5,150,35,29,17,238,2,235,5,239,2,179,1,244,2,140,77,240,2,0,0,164,165,37,73,36,146,73,37,36,146,148,148,137,36,146,73,36,148,146,73,36,146,73,36,161,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [139,0,5,126,35,12,17,248,2,252,5,240,2,175,1,2,3,127,77,252,2,0,0,164,165,36,148,146,73,36,146,146,73,74,74,68,146,73,36,146,74,73,36,146,73,36,164,161,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [139,0,5,153,35,29,17,235,2,179,1,239,2,4,6,249,2,136,77,249,2,0,0,149,41,82,149,85,85,74,170,82,165,21,85,85,84,170,170,170,170,82,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [139,0,5,124,35,36,17,237,2,178,1,232,2,3,6,251,2,133,77,242,2,0,0,149,41,84,149,85,85,74,170,82,165,21,85,85,84,170,170,170,169,41,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [139,0,5,128,35,28,17,238,2,173,1,237,2,2,6,245,2,140,77,251,2,0,0,149,41,82,74,170,170,165,85,41,82,138,170,170,170,85,85,85,85,73,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [139,0,5,126,35,30,17,236,2,160,1,236,2,2,6,246,2,135,77,246,2,0,0,149,41,85,74,170,170,149,84,165,74,42,170,170,169,85,85,85,82,146,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [139,0,5,242,2,176,1,157,35,245,16,9,3,2,6,251,2,134,77,18,3,0,0,78,103,57,255,207,204,230,63,255,63,255,201,33,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [139,0,5,237,2,177,1,120,35,16,17,245,2,6,6,241,2,141,77,243,2,0,0,78,103,153,255,207,204,230,63,255,63,255,146,72,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [139,0,5,240,2,179,1,127,35,21,17,242,2,2,6,252,2,140,77,234,2,0,0,78,103,38,127,243,243,57,143,255,207,255,254,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [139,0,5,242,2,178,1,157,35,27,17,239,2,230,5,250,2,134,77,247,2,0,0,78,103,201,255,207,204,230,63,255,63,255,158,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [139,0,5,241,2,177,1,158,35,14,17,246,2,0,6,240,2,138,77,18,3,0,0,78,103,50,127,243,243,57,143,255,207,255,243,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [139,0,5,238,2,180,1,144,35,14,17,244,2,0,6,245,2,136,77,246,2,0,0,78,103,146,127,243,243,57,143,255,207,255,228,225,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,124,35,27,17,236,2,10,6,233,2,183,1,243,2,145,77,239,2,0,0,164,170,73,36,146,73,36,146,146,73,74,74,68,146,73,36,146,74,73,36,146,73,36,165,33,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,153,35,25,17,233,2,177,1,242,2,13,6,245,2,138,77,5,3,0,0,149,36,169,85,85,85,74,170,82,165,21,85,85,84,170,170,170,170,74,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,138,35,17,17,239,2,179,1,243,2,7,6,250,2,138,77,254,2,0,0,149,36,170,85,85,85,74,170,82,165,21,85,85,84,170,170,170,169,37,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,129,35,29,17,235,2,179,1,238,2,6,6,241,2,141,77,245,2,0,0,149,36,169,42,170,170,165,85,41,82,138,170,170,170,85,85,85,85,82,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,126,35,18,17,236,2,178,1,244,2,253,5,245,2,127,77,243,2,0,0,149,36,170,149,85,85,74,170,82,165,21,85,85,84,170,170,170,169,82,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,156,35,19,17,239,2,177,1,245,2,2,6,249,2,129,77,249,2,0,0,149,36,169,74,170,170,165,85,41,82,138,170,170,170,85,85,85,85,41,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,124,35,26,17,242,2,178,1,238,2,228,5,241,2,126,77,249,2,0,0,149,36,170,74,170,170,165,85,41,82,138,170,170,170,85,85,85,84,148,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,240,2,6,6,147,35,21,17,233,2,176,1,251,2,99,77,251,2,0,0,100,242,121,36,146,73,38,73,38,100,200,146,73,36,146,73,146,73,36,146,73,36,225,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,125,35,246,16,6,3,6,6,239,2,178,1,245,2,130,77,244,2,0,0,164,170,73,37,36,146,73,37,36,146,148,148,137,36,146,73,36,148,146,73,36,146,73,74,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,246,2,254,5,156,35,14,17,237,2,176,1,239,2,136,77,237,2,0,0,100,242,100,201,36,146,73,146,73,153,50,36,146,73,36,146,100,146,73,36,146,73,225,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,154,35,20,17,241,2,242,5,239,2,179,1,245,2,141,77,250,2,0,0,164,170,73,74,73,36,146,74,73,37,41,41,18,73,36,146,73,41,36,146,73,36,146,170,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,132,35,14,17,238,2,176,1,247,2,240,5,250,2,126,77,248,2,0,0,149,36,169,41,85,85,82,170,148,169,69,85,85,85,42,170,170,170,170,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,239,2,180,1,128,35,15,17,244,2,2,6,248,2,135,77,248,2,0,0,78,73,242,127,243,243,57,143,255,207,255,231,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,239,2,151,1,125,35,19,17,242,2,2,6,10,3,139,77,249,2,0,0,78,73,204,159,252,252,206,99,255,243,255,252,225,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,154,35,20,17,240,2,174,1,239,2,1,6,250,2,132,77,254,2,0,0,149,36,170,73,85,85,82,170,148,169,69,85,85,85,42,170,170,170,74,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,128,35,24,17,231,2,184,1,238,2,31,6,235,2,135,77,224,2,0,0,169,42,170,170,170,170,85,82,149,40,170,170,170,165,85,85,85,85,33,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,126,35,18,17,236,2,158,1,239,2,2,6,11,3,143,77,240,2,0,0,169,42,165,85,85,85,42,169,74,148,85,85,85,82,170,170,170,165,72,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,157,35,27,17,232,2,179,1,236,2,8,6,245,2,147,77,242,2,0,0,169,42,169,85,85,85,42,169,74,148,85,85,85,82,170,170,170,169,72,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,127,35,19,17,237,2,181,1,240,2,7,6,240,2,142,77,237,2,0,0,169,42,164,170,170,170,149,84,165,74,42,170,170,169,85,85,85,82,82,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,181,35,25,17,235,2,178,1,242,2,3,6,11,3,131,77,242,2,0,0,169,42,170,85,85,85,42,169,74,148,85,85,85,82,170,170,170,170,72,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,141,35,19,17,234,2,178,1,242,2,7,6,250,2,137,77,238,2,0,0,169,42,165,42,170,170,149,84,165,74,42,170,170,169,85,85,85,82,146,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,132,35,26,17,235,2,177,1,241,2,254,5,252,2,138,77,249,2,0,0,169,42,169,42,170,170,149,84,165,74,42,170,170,169,85,85,85,84,146,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,161,35,242,16,241,2,175,1,243,2,2,6,252,2,133,77,18,3,0,0,169,42,164,149,85,85,74,170,82,165,21,85,85,84,170,170,170,169,36,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,154,35,24,17,236,2,179,1,247,2,5,6,245,2,149,77,243,2,0,0,169,42,170,149,85,85,42,169,74,148,85,85,85,82,170,170,170,170,161,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,131,35,18,17,240,2,177,1,244,2,254,5,249,2,149,77,252,2,0,0,169,42,165,74,170,170,149,84,165,74,42,170,170,169,85,85,85,82,168,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,146,35,15,17,235,2,179,1,243,2,243,5,241,2,136,77,250,2,0,0,169,42,169,74,170,170,149,84,165,74,42,170,170,169,85,85,85,84,168,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,128,35,26,17,234,2,180,1,242,2,251,5,250,2,146,77,252,2,0,0,169,42,164,165,85,85,74,170,82,165,21,85,85,84,170,170,170,169,42,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,133,35,21,17,237,2,176,1,247,2,1,6,246,2,139,77,29,3,0,0,169,42,170,74,170,170,149,84,165,74,42,170,170,169,85,85,85,85,40,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,134,35,18,17,239,2,176,1,246,2,1,6,4,3,0,0,251,2,129,77,169,42,165,37,85,85,74,170,82,165,10,170,170,170,85,85,85,84,165,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,153,35,20,17,239,2,178,1,243,2,253,5,255,2,128,77,245,2,0,0,169,42,169,37,85,85,74,170,82,165,21,85,85,84,170,170,170,170,74,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [139,0,5,156,35,26,17,225,2,180,1,13,3,3,6,241,2,144,77,238,2,0,0,169,37,85,85,85,85,42,169,74,148,85,85,85,82,170,170,170,170,144,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [139,0,5,149,35,23,17,234,2,180,1,243,2,1,6,244,2,133,77,245,2,0,0,169,37,82,170,170,170,149,84,165,74,42,170,170,169,85,85,85,82,164,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [139,0,5,186,35,24,17,235,2,180,1,244,2,255,5,239,2,148,77,246,2,0,0,169,37,84,170,170,170,149,84,165,74,42,170,170,169,85,85,85,84,164,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [139,0,5,153,35,23,17,236,2,172,1,238,2,2,6,244,2,133,77,239,2,0,0,169,37,82,85,85,85,74,170,82,165,21,85,85,84,170,170,170,169,41,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [139,0,5,159,35,26,17,232,2,181,1,237,2,254,5,244,2,146,77,246,2,0,0,169,37,85,42,170,170,149,84,165,74,42,170,170,169,85,85,85,85,36,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [139,0,5,122,35,25,17,232,2,178,1,244,2,255,5,238,2,143,77,222,2,0,0,169,37,82,149,85,85,74,170,82,165,21,85,85,84,170,170,170,169,73,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [139,0,5,126,35,28,17,235,2,177,1,242,2,232,5,247,2,131,77,246,2,0,0,169,37,84,149,85,85,74,170,82,165,21,85,85,84,170,170,170,170,73,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [139,0,5,124,35,21,17,237,2,179,1,244,2,2,6,236,2,137,77,245,2,0,0,169,37,82,74,170,170,165,85,41,82,138,170,170,170,85,85,85,84,146,66],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [139,0,5,131,35,15,17,238,2,179,1,247,2,251,5,245,2,141,77,249,2,0,0,169,37,85,74,170,170,149,84,165,74,42,170,170,169,85,85,85,85,80,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [139,0,5,157,35,23,17,237,2,178,1,247,2,2,6,252,2,140,77,246,2,0,0,169,37,82,165,85,85,74,170,82,165,21,85,85,84,170,170,170,169,84,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [139,0,5,129,35,20,17,239,2,177,1,243,2,2,6,247,2,135,77,238,2,0,0,169,37,84,165,85,85,74,170,82,165,21,85,85,84,170,170,170,170,84,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [139,0,5,139,35,25,17,238,2,176,1,241,2,5,6,252,2,131,77,247,2,0,0,169,37,82,82,170,170,165,85,41,82,138,170,170,170,85,85,85,84,149,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [139,0,5,154,35,18,17,239,2,178,1,240,2,1,6,247,2,133,77,243,2,0,0,169,37,85,37,85,85,74,170,82,165,21,85,85,84,170,170,170,170,148,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [139,0,5,152,35,16,17,238,2,177,1,242,2,4,6,24,3,142,77,248,2,0,0,169,37,82,146,170,170,165,85,41,82,138,170,170,170,85,85,85,84,165,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [139,0,5,191,35,15,17,237,2,176,1,244,2,4,6,244,2,139,77,239,2,0,0,169,37,84,146,170,170,165,85,41,82,138,170,170,170,85,85,85,85,37,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [139,0,5,125,35,20,17,236,2,181,1,238,2,9,6,241,2,149,77,234,2,0,0,169,41,85,85,85,85,42,169,74,148,85,85,85,82,170,170,170,170,144,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [139,0,5,129,35,21,17,231,2,180,1,240,2,27,6,247,2,138,77,242,2,0,0,169,41,82,170,170,170,149,84,165,74,42,170,170,169,85,85,85,82,164,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [139,0,5,154,35,31,17,228,2,181,1,241,2,29,6,240,2,140,77,221,2,0,0,169,41,84,170,170,170,149,84,165,74,42,170,170,169,85,85,85,84,164,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [139,0,5,145,35,21,17,233,2,181,1,234,2,18,6,242,2,148,77,225,2,0,0,169,41,82,85,85,85,74,170,82,165,21,85,85,84,170,170,170,169,41,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [139,0,5,147,35,26,17,231,2,180,1,238,2,31,6,237,2,141,77,221,2,0,0,169,41,85,42,170,170,149,84,165,74,42,170,170,169,85,85,85,85,36,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [139,0,5,124,35,18,17,233,2,180,1,240,2,28,6,235,2,139,77,222,2,0,0,169,41,82,149,85,85,74,170,82,165,21,85,85,84,170,170,170,169,73,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [139,0,5,151,35,24,17,231,2,184,1,238,2,29,6,239,2,149,77,221,2,0,0,169,41,84,149,85,85,74,170,82,165,21,85,85,84,170,170,170,170,73,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [139,0,5,157,35,15,17,238,2,182,1,241,2,2,6,240,2,142,77,238,2,0,0,169,41,82,74,170,170,165,85,41,82,138,170,170,170,85,85,85,84,146,66],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [139,0,5,153,35,30,17,235,2,175,1,246,2,7,6,247,2,152,77,250,2,0,0,169,41,85,74,170,170,149,84,165,74,42,170,170,169,85,85,85,85,80,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [139,0,5,126,35,17,17,239,2,176,1,244,2,5,6,242,2,135,77,241,2,0,0,169,41,82,165,85,85,74,170,82,165,21,85,85,84,170,170,170,169,84,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [139,0,5,149,35,29,17,236,2,177,1,241,2,4,6,245,2,137,77,242,2,0,0,169,41,84,165,85,85,74,170,82,165,21,85,85,84,170,170,170,170,84,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [139,0,5,119,35,249,16,240,2,179,1,241,2,5,6,245,2,135,77,245,2,0,0,169,41,82,82,170,170,165,85,41,82,138,170,170,170,85,85,85,84,149,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [139,0,5,122,35,28,17,238,2,155,1,244,2,3,6,250,2,130,77,246,2,0,0,169,41,85,37,85,85,74,170,82,165,21,85,85,84,170,170,170,170,148,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [139,0,5,124,35,22,17,235,2,175,1,239,2,7,6,240,2,146,77,239,2,0,0,169,41,82,146,170,170,165,85,41,82,138,170,170,170,85,85,85,84,165,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [139,0,5,122,35,9,17,238,2,181,1,241,2,3,6,248,2,142,77,241,2,0,0,169,41,84,146,170,170,165,85,41,82,138,170,170,170,85,85,85,85,37,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,230,2,181,1,150,35,29,17,243,2,28,6,240,2,138,77,247,2,0,0,114,73,255,255,63,51,152,255,252,255,255,200,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,233,2,179,1,119,35,18,17,237,2,28,6,10,3,165,77,243,2,0,0,114,73,207,255,207,204,230,63,255,63,255,156,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,236,2,177,1,148,35,20,17,9,3,5,6,245,2,139,77,235,2,0,0,114,73,231,255,207,204,230,63,255,63,255,204,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,233,2,183,1,150,35,28,17,235,2,3,6,245,2,145,77,243,2,0,0,114,73,201,255,243,243,57,143,255,207,255,228,200,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,240,2,177,1,130,35,21,17,240,2,236,5,243,2,138,77,29,3,0,0,114,73,243,255,207,204,230,63,255,63,255,228,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,234,2,181,1,128,35,30,17,240,2,6,6,242,2,145,77,243,2,0,0,114,73,204,255,243,243,57,143,255,207,255,230,72,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,148,35,20,17,233,2,180,1,243,2,230,5,249,2,131,77,242,2,0,0,169,36,170,74,170,170,165,85,41,82,138,170,170,170,85,85,85,85,36,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,236,2,165,1,150,35,21,17,4,3,0,6,244,2,142,77,236,2,0,0,114,73,201,63,252,252,206,99,255,243,255,249,36,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,152,35,26,17,235,2,160,1,242,2,7,6,250,2,138,77,247,2,0,0,169,36,170,165,85,85,74,170,82,165,21,85,85,84,170,170,170,170,168,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,128,35,19,17,238,2,180,1,236,2,6,6,10,3,144,77,242,2,0,0,169,36,169,82,170,170,165,85,41,82,138,170,170,170,85,85,85,84,170,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,235,2,182,1,125,35,18,17,238,2,255,5,240,2,136,77,15,3,0,0,114,73,230,127,243,243,57,143,255,207,255,243,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,235,2,182,1,176,35,18,17,241,2,3,6,246,2,147,77,240,2,0,0,114,73,201,159,252,252,206,99,255,243,255,249,56,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,122,35,25,17,235,2,171,1,238,2,6,6,20,3,139,77,250,2,0,0,169,36,170,146,170,170,165,85,41,82,138,170,170,170,85,85,85,85,74,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,156,35,24,17,236,2,181,1,236,2,4,6,243,2,142,77,248,2,0,0,169,36,169,73,85,85,82,170,148,169,69,85,85,85,42,170,170,170,82,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,128,35,25,17,235,2,160,1,0,3,5,6,245,2,134,77,241,2,0,0,169,36,170,73,85,85,82,170,148,169,69,85,85,85,42,170,170,170,146,132],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,124,35,24,17,227,2,166,1,239,2,29,6,250,2,141,77,227,2,0,0,170,85,74,149,85,85,42,169,74,148,82,170,170,169,85,85,85,82,146,16],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_LOW",
      command: [139,0,5,228,2,184,1,142,35,19,17,3,3,29,6,240,2,140,77,222,2,0,0,121,60,231,255,63,51,152,207,255,63,255,153,33,0],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_MID",
      command: [139,0,5,148,35,28,17,227,2,177,1,238,2,29,6,246,2,146,77,223,2,0,0,170,82,165,74,170,170,149,84,165,74,41,85,85,84,170,170,170,169,73,8],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,231,2,180,1,128,35,24,17,253,2,26,6,244,2,144,77,234,2,0,0,121,39,57,255,207,204,230,51,255,207,255,230,72,64],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [139,0,5,229,2,178,1,123,35,21,17,240,2,29,6,239,2,136,77,248,2,0,0,102,76,255,255,63,51,152,159,255,63,255,201,132],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [139,0,5,237,2,163,1,154,35,22,17,252,2,4,6,247,2,134,77,245,2,0,0,102,76,207,255,207,204,230,39,255,207,255,228,152,64],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [139,0,5,237,2,179,1,122,35,22,17,238,2,5,6,244,2,137,77,244,2,0,0,102,76,231,255,207,204,230,39,255,207,255,252,132],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [139,0,5,130,35,18,17,237,2,180,1,240,2,2,6,248,2,136,77,247,2,0,0,165,37,41,42,170,170,165,85,41,82,137,85,85,85,42,170,170,170,84,132],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [139,0,5,236,2,176,1,124,35,20,17,245,2,2,6,246,2,137,77,249,2,0,0,102,76,243,255,207,204,230,39,255,207,255,243,33,0],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [139,0,5,236,2,181,1,128,35,20,17,240,2,21,6,248,2,138,77,243,2,0,0,102,76,204,255,243,243,57,137,255,243,255,249,50,16],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [139,0,5,125,35,31,17,235,2,181,1,238,2,5,6,235,2,138,77,246,2,0,0,165,37,42,74,170,170,165,85,41,82,137,85,85,85,42,170,170,170,164,132],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [139,0,5,119,35,22,17,235,2,183,1,236,2,9,6,247,2,135,77,246,2,0,0,165,37,41,37,85,85,82,170,148,169,68,170,170,170,149,85,85,85,41,33,0],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [139,0,5,133,35,30,17,235,2,182,1,238,2,5,6,247,2,150,77,240,2,0,0,165,37,42,165,85,85,74,170,82,165,18,170,170,170,85,85,85,85,36,132],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [139,0,5,122,35,25,17,233,2,177,1,239,2,15,6,247,2,137,77,234,2,0,0,165,37,41,82,170,170,165,85,41,82,137,85,85,85,42,170,170,170,73,33,0],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [139,0,5,120,35,31,17,234,2,178,1,238,2,11,6,239,2,134,77,234,2,0,0,165,37,42,82,170,170,165,85,41,82,137,85,85,85,42,170,170,170,170,16],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [139,0,5,236,2,180,1,121,35,24,17,241,2,1,6,248,2,136,77,242,2,0,0,102,76,201,159,252,252,206,98,127,252,255,254,120,64],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [139,0,5,235,2,180,1,124,35,29,17,240,2,16,6,244,2,139,77,244,2,0,0,102,76,242,127,243,243,57,137,255,243,255,252,225,0],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [139,0,5,117,35,27,17,236,2,181,1,240,2,5,6,244,2,135,77,243,2,0,0,165,37,41,73,85,85,82,170,148,169,68,170,170,170,149,85,85,85,37,66],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [139,0,5,236,2,180,1,155,35,28,17,239,2,2,6,240,2,146,77,7,3,0,0,102,76,228,159,252,252,206,98,127,252,255,255,152,64],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,158,35,30,17,235,2,30,6,221,2,164,1,242,2,152,77,239,2,0,0,169,73,73,36,146,73,36,146,146,73,74,74,69,36,146,73,36,148,146,73,36,146,73,84,132],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,132,35,20,17,244,2,10,6,238,2,177,1,241,2,141,77,246,2,0,0,169,73,74,73,36,146,73,37,36,146,148,148,138,73,36,146,73,41,36,146,73,36,146,73,66],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,127,35,33,17,233,2,31,6,222,2,181,1,241,2,148,77,227,2,0,0,169,73,73,73,36,146,73,37,36,146,148,148,138,73,36,146,73,41,36,146,73,36,146,146,132],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,126,35,18,17,240,2,10,6,228,2,158,1,238,2,151,77,248,2,0,0,169,73,74,146,73,36,146,74,73,37,41,41,20,146,73,36,146,82,73,36,146,73,36,165,8],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,243,2,5,6,145,35,20,17,235,2,160,1,236,2,143,77,239,2,0,0,115,38,73,146,73,36,146,100,146,102,76,140,146,73,36,146,100,146,73,36,146,78,97,0],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,180,35,23,17,241,2,3,6,236,2,180,1,241,2,138,77,240,2,0,0,169,73,74,82,73,36,146,74,73,37,41,41,20,146,73,36,146,82,73,36,146,73,36,149,8],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,245,2,0,6,150,35,19,17,235,2,175,1,243,2,147,77,238,2,0,0,115,38,78,73,36,146,73,146,73,153,50,50,73,36,146,73,146,73,36,146,73,51,132],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,150,35,29,17,234,2,9,6,236,2,183,1,247,2,142,77,238,2,0,0,169,73,74,164,146,73,36,148,146,74,82,82,41,36,146,73,36,164,146,73,36,146,73,84,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,239,2,4,6,130,35,26,17,236,2,180,1,244,2,139,77,244,2,0,0,115,38,73,50,73,36,146,100,146,102,76,140,146,73,36,146,100,146,73,36,146,79,132],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,123,35,31,17,235,2,16,6,221,2,181,1,236,2,148,77,247,2,0,0,169,73,74,74,73,36,146,74,73,37,41,41,20,146,73,36,146,82,73,36,146,73,36,146,66],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,236,2,9,6,123,35,30,17,235,2,180,1,10,3,115,77,241,2,0,0,115,38,76,201,36,146,73,146,73,153,50,50,73,36,146,73,146,73,36,146,73,50,72,64],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,238,2,8,6,168,35,26,17,234,2,161,1,246,2,147,77,240,2,0,0,115,38,115,36,146,73,38,73,38,100,200,201,36,146,73,38,73,36,146,73,36,153,33,0],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,149,35,20,17,222,2,183,1,238,2,28,6,246,2,141,77,247,2,0,0,146,149,42,146,170,170,165,85,41,82,137,85,85,85,42,170,170,170,74,132],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,123,35,29,17,236,2,26,6,221,2,179,1,246,2,134,77,246,2,0,0,169,73,74,84,146,73,36,148,146,74,82,82,41,36,146,73,36,164,146,73,36,146,73,41,8],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [139,0,5,124,35,24,17,242,2,0,6,236,2,174,1,241,2,134,77,240,2,0,0,169,73,73,84,146,73,36,148,146,74,82,82,41,36,146,73,36,164,146,73,36,146,74,82,16],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [139,0,5,223,2,181,1,156,35,253,16,4,3,14,6,245,2,155,77,241,2,0,0,73,147,63,255,207,204,230,39,255,207,255,228,152,64],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [139,0,5,182,35,49,17,219,2,8,6,236,2,179,1,21,3,138,77,244,2,0,0,169,82,148,146,73,36,146,74,73,37,41,41,20,146,73,36,146,82,73,36,146,73,36,146,132],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [139,0,5,128,35,24,17,236,2,180,1,239,2,5,6,4,3,146,77,11,3,0,0,146,146,149,42,170,170,165,85,41,82,137,85,85,85,42,170,170,170,84,132],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [139,0,5,223,2,178,1,162,35,20,17,240,2,20,6,250,2,134,77,225,2,0,0,73,147,50,127,252,252,206,98,127,252,255,255,50,16],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [139,0,5,236,2,179,1,182,35,18,17,241,2,6,6,246,2,157,77,250,2,0,0,73,147,60,255,243,243,57,137,255,243,255,249,50,16],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [139,0,5,149,35,20,17,222,2,181,1,240,2,27,6,243,2,137,77,243,2,0,0,146,146,148,165,85,85,82,170,148,169,68,170,170,170,149,85,85,85,82,66],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [139,0,5,128,35,20,17,238,2,178,1,242,2,0,6,251,2,152,77,248,2,0,0,146,146,149,37,85,85,82,170,148,169,68,170,170,170,149,85,85,85,41,33,0],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [139,0,5,148,35,24,17,233,2,179,1,238,2,3,6,252,2,144,77,9,3,0,0,146,146,148,146,170,170,169,85,74,84,162,85,85,85,74,170,170,170,164,144,128],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [139,0,5,127,35,29,17,236,2,178,1,238,2,4,6,247,2,145,77,244,2,0,0,146,146,149,82,170,170,165,85,41,82,137,85,85,85,42,170,170,170,73,33,0],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [139,0,5,123,35,18,17,233,2,182,1,240,2,4,6,249,2,142,77,241,2,0,0,146,146,148,169,85,85,82,170,148,169,68,170,170,170,149,85,85,85,85,8],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [139,0,5,235,2,180,1,151,35,22,17,239,2,3,6,246,2,146,77,251,2,0,0,73,147,57,159,252,252,206,98,127,252,255,254,120,64],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [139,0,5,180,35,33,17,234,2,180,1,236,2,4,6,237,2,111,77,244,2,0,0,146,146,148,148,170,170,169,85,74,84,162,85,85,85,74,170,170,170,165,66],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [139,0,5,126,35,28,17,229,2,181,1,236,2,255,5,246,2,154,77,237,2,0,0,146,146,149,73,85,85,82,170,148,169,68,170,170,170,149,85,85,85,37,66],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [139,0,5,124,35,248,16,233,2,179,1,7,3,2,6,249,2,141,77,240,2,0,0,146,146,148,164,170,170,169,85,74,84,162,85,85,85,74,170,170,170,169,66],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [139,0,5,124,35,25,17,235,2,181,1,237,2,3,6,235,2,165,77,236,2,0,0,146,146,149,36,170,170,169,85,74,84,162,85,85,85,74,170,170,170,148,161,0],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [139,0,5,234,2,179,1,144,35,24,17,240,2,8,6,247,2,143,77,239,2,0,0,73,153,63,255,207,204,230,39,255,207,255,228,152,64],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [139,0,5,221,2,181,1,129,35,20,17,239,2,29,6,247,2,145,77,226,2,0,0,73,153,51,255,243,243,57,137,255,243,255,255,33,0],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [139,0,5,116,35,18,17,241,2,23,6,231,2,178,1,15,3,144,77,244,2,0,0,169,74,146,146,73,36,146,74,73,37,41,41,20,146,73,36,146,82,73,36,146,73,37,37,8],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [139,0,5,234,2,182,1,239,2,9,6,150,35,22,17,236,2,149,77,12,3,0,0,43,107,95,255,126,221,139,255,239,255,246,132],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [139,0,5,237,2,181,1,155,35,2,17,253,2,7,6,250,2,150,77,241,2,0,0,73,153,60,255,243,243,57,137,255,243,255,249,50,16],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [139,0,5,131,35,23,17,240,2,7,6,234,2,181,1,16,3,140,77,248,2,0,0,169,74,148,164,146,73,36,148,146,74,82,82,41,36,146,73,36,164,146,73,36,146,73,42,16],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [139,0,5,124,35,29,17,235,2,179,1,239,2,3,6,245,2,141,77,241,2,0,0,146,148,149,37,85,85,82,170,148,169,68,170,170,170,149,85,85,85,41,33,0],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [139,0,5,144,35,26,17,236,2,181,1,238,2,8,6,244,2,149,77,14,3,0,0,146,148,148,146,170,170,169,85,74,84,162,85,85,85,74,170,170,170,164,144,128],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [139,0,7,151,35,22,17,236,2,182,1,241,2,2,6,242,2,33,1,145,3,6,6,243,2,145,77,243,2,0,0,146,145,9,85,42,170,170,85,82,149,40,37,85,85,84,170,170,170,169,36,129,0],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [139,0,5,124,35,18,17,236,2,182,1,241,2,8,6,247,2,154,77,236,2,0,0,146,148,148,169,85,85,82,170,148,169,68,170,170,170,149,85,85,85,85,8],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [139,0,5,125,35,17,17,235,2,163,1,242,2,6,6,246,2,156,77,246,2,0,0,146,148,149,41,85,85,82,170,148,169,68,170,170,170,149,85,85,85,42,132],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [139,0,5,146,35,20,17,237,2,180,1,240,2,6,6,248,2,152,77,237,2,0,0,146,148,148,148,170,170,169,85,74,84,162,85,85,85,74,170,170,170,165,66],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [139,0,5,190,35,22,17,236,2,161,1,246,2,224,5,246,2,142,77,244,2,0,0,146,148,149,73,85,85,82,170,148,169,68,170,170,170,149,85,85,85,37,66],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [139,0,5,155,35,21,17,237,2,179,1,242,2,2,6,249,2,139,77,18,3,0,0,146,148,148,164,170,170,169,85,74,84,162,85,85,85,74,170,170,170,169,66],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [139,0,5,132,35,21,17,236,2,177,1,240,2,5,6,248,2,138,77,237,2,0,0,146,148,149,36,170,170,169,85,74,84,162,85,85,85,74,170,170,170,148,161,0],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,222,2,181,1,130,35,33,17,234,2,24,6,248,2,142,77,248,2,0,0,73,146,79,255,243,243,57,137,255,243,255,249,38,16],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,235,2,179,1,122,35,34,17,232,2,10,6,242,2,137,77,243,2,0,0,73,146,76,255,252,252,206,98,127,252,255,255,200,64],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,123,35,28,17,237,2,157,1,239,2,5,6,245,2,148,77,250,2,0,0,146,146,74,149,85,85,82,170,148,169,68,170,170,170,149,85,85,85,42,66],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,235,2,180,1,123,35,22,17,243,2,2,6,249,2,144,77,244,2,0,0,73,146,76,159,255,63,51,152,159,255,63,255,204,132],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,156,35,41,17,237,2,181,1,227,2,3,6,240,2,138,77,245,2,0,0,146,146,74,165,85,85,82,170,148,169,68,170,170,170,149,85,85,85,37,33,0],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,124,35,15,17,237,2,180,1,245,2,238,5,245,2,126,77,17,3,0,0,146,146,74,82,170,170,169,85,74,84,162,85,85,85,74,170,170,170,169,33,0],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,149,35,17,17,240,2,177,1,243,2,2,6,15,3,144,77,252,2,0,0,146,146,74,146,170,170,169,85,74,84,162,85,85,85,74,170,170,170,148,144,128],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,240,2,176,1,150,35,19,17,242,2,252,5,15,3,142,77,242,2,0,0,73,146,76,147,255,207,204,230,39,255,207,255,242,72,64],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,135,35,15,17,234,2,179,1,243,2,254,5,251,2,142,77,251,2,0,0,146,146,74,169,85,85,82,170,148,169,68,170,170,170,149,85,85,85,36,144,128],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,150,35,24,17,238,2,177,1,240,2,4,6,252,2,144,77,232,2,0,0,146,146,74,84,170,170,169,85,74,84,162,85,85,85,74,170,170,170,170,132],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,241,2,174,1,158,35,9,17,246,2,252,5,5,3,123,77,252,2,0,0,73,146,78,103,255,63,51,152,159,255,63,255,158,16],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,158,35,32,17,235,2,179,1,237,2,2,6,241,2,142,77,248,2,0,0,146,146,74,74,85,85,84,170,165,42,81,42,170,170,165,85,85,85,82,161,0],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,237,2,178,1,153,35,31,17,237,2,232,5,24,3,137,77,243,2,0,0,73,146,79,39,255,63,51,152,159,255,63,255,147,132],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,239,2,177,1,188,35,18,17,242,2,1,6,2,3,148,77,240,2,0,0,73,146,76,201,255,207,204,230,39,255,207,255,249,132],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [139,0,5,137,35,23,17,238,2,180,1,240,2,6,6,249,2,136,77,248,2,0,0,146,146,74,146,85,85,84,170,165,42,81,42,170,170,165,85,85,85,74,80,128],
    },
    ]
};

export default SHARP_YB1FA
